export default "__VITE_ASSET__CaV0_Gvs__"